import { Component, OnInit, AfterViewInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { Register } from './register.service';
import { LoginModalService } from '../../shared';

import { AbstractGeograpicalDialogComponent } from '../../entities/abstract-dialog-component/abstract-geopraphical-dialog.component';
import { School, SchoolService } from '../../entities/school';
import { City, CityService } from '../../entities/city';
import { TaxService } from '../../entities/tax';
import { CountryService } from '../../entities/country';
import { AlertService } from 'ng-jhipster';
import { PASSWORD_INPUT_CLASS } from '../../shared/constants/password.constants';

import { Principal } from '../../shared';
import { Subscription } from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-register',
    templateUrl: './register.component.html'
})
export class RegisterComponent extends AbstractGeograpicalDialogComponent implements OnInit, AfterViewInit {

    confirmPassword: string;
    doNotMatch: string;
    error: string;
    errorEmailExists: string;
    errorUserExists: string;
    registerAccount: any;
    success: boolean;
    modalRef: NgbModalRef;
    private schoolSubscription: Subscription;
    private countryId: number;
    private cityId: number;
    private itemsPerPage = 30;
    protected loadingCities: boolean = false;
    schools: School[];
    private loadingSchools: boolean = false;
    schoolId: number;
    @ViewChild('registerForm') searchForm: NgForm;
    showPassword: boolean;
    passwordInputClass: string;
    showConfirmPassword: boolean;
    confirmPasswordInputClass: string;

    constructor(
        private languageService: JhiLanguageService,
        private loginModalService: LoginModalService,
        private registerService: Register,
        private elementRef: ElementRef,
        private renderer: Renderer,
        schoolService: SchoolService,
        private route: ActivatedRoute,
        countryService: CountryService,
        cityService: CityService,
        taxService: TaxService,
        alertService: AlertService,
        principal: Principal
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.languageService.setLocations(['register']);
    }

    ngOnInit() {
        this.success = false;
        this.registerAccount = {};
        this.loadGeographicalLocationsNoAuth(this.searchForm);
        this.passwordInputClass = PASSWORD_INPUT_CLASS.HIDE;
        this.confirmPasswordInputClass = PASSWORD_INPUT_CLASS.HIDE;
    }

    loadSchoolsNoAuth(form: NgForm) {
        this.loadingSchools = true;
        this.schoolService.searchNoAuth({
            query: 'city.id:' + this.cityId,
            size: this.itemsPerPage
        }).subscribe(
            (res: HttpResponse<School[]>) => {
                this.loadingSchools = false;
                let data: School[] = res.body;
                if (!data || data.length <= 0 ) {
                    this.schoolId = null;
                    this.schools = null;
                    return;
                }
                this.sortSchools(data);
                form.controls['school'].setValue(this.schools[0].id);
            }, (res: HttpErrorResponse) => this.onError(res)
            );
        return;
    }

    protected sortSchools(schools: School[]) {
        if (schools) {
            this.schools = schools.sort((a: City, b: City) =>
                        a && a.name.localeCompare(b.name));
        }
    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#login'), 'focus', []);
    }

    register() {
        if (this.registerAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        } else {
            this.doNotMatch = null;
            this.error = null;
            this.errorUserExists = null;
            this.errorEmailExists = null;
            this.languageService.getCurrent().then(key => {
                if (this.registerAccount.botField == null) {
                    // If botField is not empty upon form submission, you can assume it's a bot.
                    this.registerAccount.langKey = key;
                    this.registerAccount.tenantId = this.schoolId;
                    this.registerAccount.countryId = this.countryId;
                    this.registerAccount.cityId = this.cityId;
                    this.registerService.save(this.registerAccount).subscribe(res => {
                        this.success = true;
                    }, error => this.processError(error));
                }
            });
        }
    }

    openLogin() {
        this.modalRef = this.loginModalService.open();
    }

    toggleShowPassword(event: MouseEvent) {
        this.showPassword = !this.showPassword;
        this.passwordInputClass = this.showPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    toggleShowConfirmPassword(event: MouseEvent) {
        this.showConfirmPassword = !this.showConfirmPassword;
        this.confirmPasswordInputClass = this.showConfirmPassword ? PASSWORD_INPUT_CLASS.SHOW : PASSWORD_INPUT_CLASS.HIDE;

        // this is to not launch login upon click
        event.preventDefault();
    }

    onKeyDown(event: KeyboardEvent): void {
        // this is to not toggle the show text upon enter key
         if (event.key === 'Enter') {
          event.preventDefault();
        }
    }

    private processError(response: HttpErrorResponse) {
        this.success = null;
        if (response.status === 400 && response.error === 'login already in use') {
            this.errorUserExists = 'ERROR';
        } else if (response.status === 400 && response.error === 'e-mail address already in use') {
            this.errorEmailExists = 'ERROR';
        } else {
            this.error = 'ERROR';
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.component.ts